import {
  Account,
  AccountsResponse,
  AccountsOverviewResponse,
  AccountStatus,
} from "../entities/Accounts";

// API response structure for accounts endpoint
export interface ApiAccountsResponse {
  code: string;
  message: string;
  data: ApiAccount[];
}

// Reflects backend's AccountResponse (GET /accounts/{businessKey}) - no field invented here.
export interface ApiAccount {
  accountNumber: string;
  iban: string | null;
  accountName: string | null;
  currencyCode: string | null;
  balance: number | null; // dernier solde lu du CBS, 0 si jamais lu
  balanceUpdatedAt: string | null; // ISO datetime de la dernière lecture réussie du CBS
  accountOpeningDate: string | null; // ISO date, e.g. "2026-09-24"
  accountType: string | null; // code produit, e.g. "C"
  status: string | null; // ACTIVE, INACTIVE, CLOSED...
}

export class AccountsMapper {
  static toDomainModel(apiResponse: ApiAccountsResponse): AccountsResponse {
    return {
      code: apiResponse.code,
      message: apiResponse.message,
      data: apiResponse.data.map((item) => this.toDomainItem(item)),
    };
  }

  static toDomainOverview(
    apiResponse: ApiAccountsResponse
  ): AccountsOverviewResponse {
    return {
      code: apiResponse.code,
      message: apiResponse.message,
      data: apiResponse.data.map((item) => this.toDomainItem(item)),
    };
  }

  static toDomainItem(apiItem: ApiAccount): Account {
    return {
      id: apiItem.accountNumber,
      product: apiItem.accountName || apiItem.accountType || "",
      reference: apiItem.accountNumber || "",
      status: this.mapStatus(apiItem.status),
      balance: apiItem.balance ?? 0,
      currency: apiItem.currencyCode || "XOF",
      iban: apiItem.iban || null,
      openAt: this.formatDate(apiItem.accountOpeningDate),
      accountNumber: apiItem.accountNumber,
    };
  }

  static toDomainItems(apiItems: ApiAccount[]): Account[] {
    return apiItems.map((item) => this.toDomainItem(item));
  }

  /** Statut du compte tel que le backend le renvoie ; un statut absent ou inconnu se lit comme actif. */
  private static mapStatus(status: string | null): AccountStatus {
    const normalized = (status ?? "").toUpperCase().trim();
    if (normalized === "INACTIVE" || normalized === "INACTIF") return "INACTIVE";
    if (normalized === "CLOSED" || normalized === "FERME") return "CLOSED";
    if (normalized === "SUSPENDED" || normalized === "SUSPENDU") return "SUSPENDED";
    return "ACTIVE";
  }

  private static formatDate(dateString: string | null): string {
    if (!dateString) return "";
    return dateString;
  }
}
